"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var theme = _interopRequireWildcard(require("."));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/*
  * Do not edit directly
  * Generated on Wed Apr 14 2021 15:45:03 GMT-0300 (GMT-03:00)
*/


var _default = {
  "fontSizes": {
    "xs": theme.FontSizesXs,
    "sm": theme.FontSizesSm,
    "md": theme.FontSizesMd,
    "lg": theme.FontSizesLg,
    "xl": theme.FontSizesXl,
    "2xl": theme.FontSizes2Xl,
    "3xl": theme.FontSizes3Xl,
    "4xl": theme.FontSizes4Xl,
    "5xl": theme.FontSizes5Xl,
    "6xl": theme.FontSizes6Xl,
    "7xl": theme.FontSizes7Xl,
    "8xl": theme.FontSizes8Xl,
    "9xl": theme.FontSizes9Xl,
    "10xl": theme.FontSizes10Xl
  },
  "fontFamily": {
    "base": theme.FontFamilyBase
  },
  "fontWeight": {
    "xs": theme.FontWeightXs,
    "sm": theme.FontWeightSm,
    "md": theme.FontWeightMd,
    "lg": theme.FontWeightLg
  },
  "letterSpacing": {
    "xs": theme.LetterSpacingXs,
    "sm": theme.LetterSpacingSm,
    "md": theme.LetterSpacingMd
  },
  "lineHeight": {
    "xs": theme.LineHeightXs,
    "sm": theme.LineHeightSm,
    "md": theme.LineHeightMd,
    "lg": theme.LineHeightLg,
    "xl": theme.LineHeightXl,
    "2xl": theme.LineHeight2Xl,
    "3xl": theme.LineHeight3Xl,
    "4xl": theme.LineHeight4Xl,
    "5xl": theme.LineHeight5Xl,
    "6xl": theme.LineHeight6Xl,
    "7xl": theme.LineHeight7Xl,
    "8xl": theme.LineHeight8Xl
  },
  "colors": {
    "error": {
      "60": theme.ColorError60
    },
    "neutral": {
      "0": theme.ColorNeutral0,
      "10": theme.ColorNeutral10,
      "15": theme.ColorNeutral15,
      "20": theme.ColorNeutral20,
      "40": theme.ColorNeutral40,
      "60": theme.ColorNeutral60,
      "80": theme.ColorNeutral80,
      "90": theme.ColorNeutral90,
      "100": theme.ColorNeutral100
    },
    "primary": {
      "40": theme.ColorPrimary40,
      "60": theme.ColorPrimary60,
      "80": theme.ColorPrimary80
    },
    "secondary": {
      "20": theme.ColorSecondary20,
      "40": theme.ColorSecondary40,
      "60": theme.ColorSecondary60
    },
    "warning": {
      "60": theme.ColorWarning60
    },
    "informational": {
      "60": theme.ColorInformational60
    }
  },
  "spacingX": {
    "xs": theme.SpacingXXs,
    "sm": theme.SpacingXSm,
    "md": theme.SpacingXMd,
    "lg": theme.SpacingXLg,
    "xl": theme.SpacingXXl,
    "2xl": theme.SpacingX2Xl,
    "3xl": theme.SpacingX3Xl,
    "4xl": theme.SpacingX4Xl,
    "5xl": theme.SpacingX5Xl,
    "6xl": theme.SpacingX6Xl,
    "7xl": theme.SpacingX7Xl,
    "8xl": theme.SpacingX8Xl,
    "9xl": theme.SpacingX9Xl,
    "10xl": theme.SpacingX10Xl,
    "11xl": theme.SpacingX11Xl,
    "12xl": theme.SpacingX12Xl,
    "13xl": theme.SpacingX13Xl,
    "14xl": theme.SpacingX14Xl,
    "15xl": theme.SpacingX15Xl,
    "16xl": theme.SpacingX16Xl,
    "17xl": theme.SpacingX17Xl,
    "18xl": theme.SpacingX18Xl,
    "19xl": theme.SpacingX19Xl,
    "20xl": theme.SpacingX20Xl,
    "21xl": theme.SpacingX21Xl,
    "22xl": theme.SpacingX22Xl,
    "23xl": theme.SpacingX23Xl
  },
  "spacingY": {
    "xs": theme.SpacingYXs,
    "sm": theme.SpacingYSm,
    "md": theme.SpacingYMd,
    "lg": theme.SpacingYLg,
    "xl": theme.SpacingYXl,
    "2xl": theme.SpacingY2Xl,
    "3xl": theme.SpacingY3Xl,
    "4xl": theme.SpacingY4Xl,
    "5xl": theme.SpacingY5Xl,
    "6xl": theme.SpacingY6Xl,
    "7xl": theme.SpacingY7Xl,
    "8xl": theme.SpacingY8Xl,
    "9xl": theme.SpacingY9Xl,
    "10xl": theme.SpacingY10Xl,
    "11xl": theme.SpacingY11Xl,
    "12xl": theme.SpacingY12Xl,
    "13xl": theme.SpacingY13Xl,
    "14xl": theme.SpacingY14Xl,
    "15xl": theme.SpacingY15Xl,
    "16xl": theme.SpacingY16Xl,
    "17xl": theme.SpacingY17Xl,
    "18xl": theme.SpacingY18Xl,
    "19xl": theme.SpacingY19Xl,
    "20xl": theme.SpacingY20Xl,
    "21xl": theme.SpacingY21Xl,
    "22xl": theme.SpacingY22Xl,
    "23xl": theme.SpacingY23Xl
  },
  "spacingBottom": {
    "xs": theme.SpacingBottomXs,
    "sm": theme.SpacingBottomSm,
    "md": theme.SpacingBottomMd,
    "lg": theme.SpacingBottomLg,
    "xl": theme.SpacingBottomXl,
    "2xl": theme.SpacingBottom2Xl,
    "3xl": theme.SpacingBottom3Xl,
    "4xl": theme.SpacingBottom4Xl,
    "5xl": theme.SpacingBottom5Xl,
    "6xl": theme.SpacingBottom6Xl,
    "7xl": theme.SpacingBottom7Xl,
    "8xl": theme.SpacingBottom8Xl,
    "9xl": theme.SpacingBottom9Xl,
    "10xl": theme.SpacingBottom10Xl,
    "11xl": theme.SpacingBottom11Xl,
    "12xl": theme.SpacingBottom12Xl,
    "13xl": theme.SpacingBottom13Xl,
    "14xl": theme.SpacingBottom14Xl,
    "15xl": theme.SpacingBottom15Xl,
    "16xl": theme.SpacingBottom16Xl,
    "17xl": theme.SpacingBottom17Xl,
    "18xl": theme.SpacingBottom18Xl,
    "19xl": theme.SpacingBottom19Xl,
    "20xl": theme.SpacingBottom20Xl,
    "21xl": theme.SpacingBottom21Xl,
    "22xl": theme.SpacingBottom22Xl,
    "23xl": theme.SpacingBottom23Xl
  },
  "spacingRight": {
    "xs": theme.SpacingRightXs,
    "sm": theme.SpacingRightSm,
    "md": theme.SpacingRightMd,
    "lg": theme.SpacingRightLg,
    "xl": theme.SpacingRightXl,
    "2xl": theme.SpacingRight2Xl,
    "3xl": theme.SpacingRight3Xl,
    "4xl": theme.SpacingRight4Xl,
    "5xl": theme.SpacingRight5Xl,
    "6xl": theme.SpacingRight6Xl,
    "7xl": theme.SpacingRight7Xl,
    "8xl": theme.SpacingRight8Xl,
    "9xl": theme.SpacingRight9Xl,
    "10xl": theme.SpacingRight10Xl,
    "11xl": theme.SpacingRight11Xl,
    "12xl": theme.SpacingRight12Xl,
    "13xl": theme.SpacingRight13Xl,
    "14xl": theme.SpacingRight14Xl,
    "15xl": theme.SpacingRight15Xl,
    "16xl": theme.SpacingRight16Xl,
    "17xl": theme.SpacingRight17Xl,
    "18xl": theme.SpacingRight18Xl,
    "19xl": theme.SpacingRight19Xl,
    "20xl": theme.SpacingRight20Xl,
    "21xl": theme.SpacingRight21Xl,
    "22xl": theme.SpacingRight22Xl,
    "23xl": theme.SpacingRight23Xl
  },
  "spacingTop": {
    "xs": theme.SpacingTopXs,
    "sm": theme.SpacingTopSm,
    "md": theme.SpacingTopMd,
    "lg": theme.SpacingTopLg,
    "xl": theme.SpacingTopXl,
    "2xl": theme.SpacingTop2Xl,
    "3xl": theme.SpacingTop3Xl,
    "4xl": theme.SpacingTop4Xl,
    "5xl": theme.SpacingTop5Xl,
    "6xl": theme.SpacingTop6Xl,
    "7xl": theme.SpacingTop7Xl,
    "8xl": theme.SpacingTop8Xl,
    "9xl": theme.SpacingTop9Xl,
    "10xl": theme.SpacingTop10Xl,
    "11xl": theme.SpacingTop11Xl,
    "12xl": theme.SpacingTop12Xl,
    "13xl": theme.SpacingTop13Xl,
    "14xl": theme.SpacingTop14Xl,
    "15xl": theme.SpacingTop15Xl,
    "16xl": theme.SpacingTop16Xl,
    "17xl": theme.SpacingTop17Xl,
    "18xl": theme.SpacingTop18Xl,
    "19xl": theme.SpacingTop19Xl,
    "20xl": theme.SpacingTop20Xl,
    "21xl": theme.SpacingTop21Xl,
    "22xl": theme.SpacingTop22Xl,
    "23xl": theme.SpacingTop23Xl
  },
  "spacingLeft": {
    "xs": theme.SpacingLeftXs,
    "sm": theme.SpacingLeftSm,
    "md": theme.SpacingLeftMd,
    "lg": theme.SpacingLeftLg,
    "xl": theme.SpacingLeftXl,
    "2xl": theme.SpacingLeft2Xl,
    "3xl": theme.SpacingLeft3Xl,
    "4xl": theme.SpacingLeft4Xl,
    "5xl": theme.SpacingLeft5Xl,
    "6xl": theme.SpacingLeft6Xl,
    "7xl": theme.SpacingLeft7Xl,
    "8xl": theme.SpacingLeft8Xl,
    "9xl": theme.SpacingLeft9Xl,
    "10xl": theme.SpacingLeft10Xl,
    "11xl": theme.SpacingLeft11Xl,
    "12xl": theme.SpacingLeft12Xl,
    "13xl": theme.SpacingLeft13Xl,
    "14xl": theme.SpacingLeft14Xl,
    "15xl": theme.SpacingLeft15Xl,
    "16xl": theme.SpacingLeft16Xl,
    "17xl": theme.SpacingLeft17Xl,
    "18xl": theme.SpacingLeft18Xl,
    "19xl": theme.SpacingLeft19Xl,
    "20xl": theme.SpacingLeft20Xl,
    "21xl": theme.SpacingLeft21Xl,
    "22xl": theme.SpacingLeft22Xl,
    "23xl": theme.SpacingLeft23Xl
  },
  "radius": {
    "xs": theme.RadiusXs,
    "sm": theme.RadiusSm,
    "md": theme.RadiusMd,
    "lg": theme.RadiusLg,
    "xl": theme.RadiusXl,
    "2xl": theme.Radius2Xl,
    "3xl": theme.Radius3Xl,
    "4xl": theme.Radius4Xl,
    "5xl": theme.Radius5Xl,
    "6xl": theme.Radius6Xl,
    "7xl": theme.Radius7Xl,
    "8xl": theme.Radius8Xl,
    "pill": theme.RadiusPill,
    "round": theme.RadiusRound
  },
  "motion": {
    "xs": theme.MotionXs,
    "sm": theme.MotionSm,
    "md": theme.MotionMd,
    "lg": theme.MotionLg,
    "xl": theme.MotionXl
  },
  "opacity": {
    "xs": theme.OpacityXs,
    "sm": theme.OpacitySm,
    "md": theme.OpacityMd,
    "lg": theme.OpacityLg,
    "xl": theme.OpacityXl,
    "2xl": theme.Opacity2Xl,
    "3xl": theme.Opacity3Xl
  },
  "stroke": {
    "xs": theme.StrokeXs,
    "sm": theme.StrokeSm,
    "md": theme.StrokeMd,
    "lg": theme.StrokeLg
  },
  "shadow": {
    "xs": theme.ShadowXs,
    "sm": theme.ShadowSm,
    "md": theme.ShadowMd,
    "lg": theme.ShadowLg
  }
};
exports["default"] = _default;